import type { Theme } from '@mui/material/styles';
import { eisTheme } from './theme';
import { suiteTheme } from './suite-theme';
import type { ChromeVariant } from './variant';

/**
 * One theme per chrome variant (SDD-012, U-2). `suite` is the legacy look for the transition;
 * `berry` is the redesign waiting behind a config flip. Same components, same density, same
 * feature code — only tokens and chrome differ. Themes are built once at module load and shared;
 * a theme object is immutable, so handing the same instance to every provider is safe.
 */
export function createEisTheme(variant: ChromeVariant): Theme {
  return variant === 'suite' ? suiteTheme : eisTheme;
}
